<template>
  <qx-card title="费用报销">
<!--    <qx-img-dialog ref="imgDialog" />-->
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
            v-loading="tableData.loading"
            ref="multipleTable"
            :data="tableData.data"
            tooltip-effect="dark"
            @select="handleSelectionChange"
            @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
              v-for="(item, index, key) in tableData.title"
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
          >
            <section slot-scope="scope">
              <seciton v-if="scope.column.property === 'zero'"><span>0</span></seciton>
              <section v-else>{{ scope.row[scope.column.property] }}</section>
            </section>
          </el-table-column>
          <!-- 常规列表项 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="tableData.currentPage"
              :page-sizes="[10, 20, 50]"
              :page-size="tableData.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import {getOrderMoneyTypeOperateRecordsByOrderId, getReceiptRecordList} from 'api/operate';
import tableMixin from '@qx/mixin/table';
export default {
  mixins: [
    tableMixin,
  ],
  props: {
    orderId: {
      type: String,
    },
  },
  data () {
    return {
      searchBoxData: {
        sourceOfGoodsId: 0,
      },
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {prop: 'zero', label: '报销金额'},
          {prop: 'zero', label: '已报销金额'},
          {prop: 'zero', label: '未报销金额'},
          {prop: 'zero', label: '司机劳务费用结算单价'},
          {prop: 'zero', label: '工资支出'},
          {prop: 'zero', label: '加气充气支出'},
          {prop: 'zero', label: 'ETC支出'},
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    // getList: getReceiptRecordList,
  },
  // created() {
  //   this.searchBoxData.orderId=this.orderId||this.$route.query.id
  //   this.getData()
  // }
};
</script>

<style scoped>

</style>
